import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';
import firebase from 'firebase';
import 'firebase/firestore';

/*
  Generated class for the FbProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FbProvider {
  firebaseRoot: any;
  currentUser: any;

  constructor(public storageServiceProvider: StorageServiceProvider) {
    console.log('Hello FbProvider Provider');
  }

  init() {
    // Initialize Firebase
    var config = {
      apiKey: "AIzaSyBUmifQBKDFDvKEctQcHknmbh5JjAsQ3gQ",
      authDomain: "btcustomer-ff246.firebaseapp.com",
      databaseURL: "https://btcustomer-ff246.firebaseio.com",
      projectId: "btcustomer-ff246",
      storageBucket: "btcustomer-ff246.appspot.com",
      messagingSenderId: "179111048418"
    };
    try {
      firebase.initializeApp(config);
      this.firebaseRoot = firebase.database().ref();
      // console.log('firebaseRoot: ' + this.firebaseRoot.toString());
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {

        if (!user) {
          unsubscribe();
        } else {
          this.currentUser = user;
          unsubscribe();
        }
      });
    } catch (error) {
      console.log('firebase init: ' + error);
    }
  }

  loginUser(email: string, password: string) {
    return firebase.auth().signInWithEmailAndPassword(email, password);
  }

  logoutUser() {
    //const userId: string = firebase.auth().currentUser.uid;
    //this.fbdb.logoutUser(userId);
    this.storageServiceProvider.clearToken();
    return firebase.auth().signOut();
  }

  signupUser(email: string, password: string) {
    return firebase.auth().createUserWithEmailAndPassword(email, password)
  }

  resetPassword(email: string) {
    return firebase.auth().sendPasswordResetEmail(email);
  }

  addUserProfileFirebase(uID, data) {
    var firestore = firebase.firestore().collection('userProfile');
    return firestore.doc(uID).set(data);
  }

  updateUserProfileFirebase(uID, data) {
    var firestore = firebase.firestore().collection('userProfile');
    return firestore.doc(uID).update(data);
  }

  uploadFileStorage(id, file) {
    return firebase.storage().ref().child('images/user/' + id + '.jpeg').putString(file, 'data_url');
  }

  downloadFileStorage(id) {
    var promise = new Promise((resolve, reject) => {
      firebase.storage().ref().child('images/user/' + id + '.jpeg').getDownloadURL().then(result => {
        resolve(result);
      }, () => {
        resolve(undefined);
      })
    })
    return promise;
  }

  updateProfile(displayName, url) {
    var user = firebase.auth().currentUser;
    return user.updateProfile({
      displayName: displayName,
      photoURL: url
    }).then(function () {
      // Update successful.
    }).catch(function (error) {
      // An error happened.
    });
  }

  updateUser(uid: string, data: any) {
    let firestore = firebase.firestore().collection('userProfile');
    return firestore.doc(uid).update(data);
  }

}



// WEBPACK FOOTER //
// ./src/providers/fb/fb.ts